/* @flow weak */
import URI from 'urijs';

export default function getPrettyUrl(url) {
  const uri = new URI(url);
  return uri.hostname().replace(/^www\./, '') + uri.resource();
}
